/** QL-380 — why a user cannot change a client's access fields. */
export const T = {
  en_GB: { readOnly: "Only the client owner or an administrator can change this." },
  nb_NO: { readOnly: "Bare kundens eier eller en administrator kan endre dette." },
} as const;
